module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("The Positions of Love Box Set")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By J.M. Snyder")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Table of Contents:")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005#a18"
    }
  }, [_vm._v("Book 1: The Positions of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/006#a19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 2: Two Pillars Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/007#a20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 3: Clasping Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/008#a21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 4: Hammock Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 5: Two Dogs Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 6: Cowboy Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 7: Kneeling Butterfly Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/012#a25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 8: Pillar and the Ivy Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/013#a26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 9: Tripod Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 10: Lotus Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 11: The Arc Position")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 12: Sideways Position")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df7843c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0